import { createAction } from "@reduxjs/toolkit";

const ACTION_PREFIX = "OPENED_PAGES";

export const setOpenedClientsPage = createAction<number>(`${ACTION_PREFIX}/SET_CLIENTS`);
export const setOpenedVendorsPage = createAction<number>(`${ACTION_PREFIX}/SET_VENDORS`);
export const setOpenedAssetsPage = createAction<number>(`${ACTION_PREFIX}/SET_ASSETS`);
export const setPreviousURLTeamMembers = createAction<string>(`${ACTION_PREFIX}/SET_TEAM_MEMBERS`);

export const setOpenedWashroomLogsPage = createAction<number>(`${ACTION_PREFIX}/SET_WASHROOM_LOGS`);
